export default "__VITE_ASSET__a5417c8a__"